import type { SVGProps } from "react";
const SvgIconLogout = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" {...props}>
    <circle cx={512} cy={512} r={512} fill="currentColor" />
    <path d="m824.68 494.32-128-128c-9.76-9.76-25.59-9.76-35.36 0-9.76 9.76-9.76 25.59 0 35.36L746.64 487H406c-13.81 0-25 11.19-25 25s11.19 25 25 25h340.64l-85.32 85.32c-9.76 9.76-9.76 25.59 0 35.36C666.2 662.56 672.6 665 679 665s12.8-2.44 17.68-7.32l128-128c9.76-9.76 9.76-25.59 0-35.36" />
    <path d="M718 231v-53H306v668h412v-53c0-13.81 11.19-25 25-25s25 11.19 25 25v53c0 27.61-22.39 50-50 50H306c-27.61 0-50-22.39-50-50V178c0-27.61 22.39-50 50-50h412c27.61 0 50 22.39 50 50v53c0 13.81-11.19 25-25 25s-25-11.19-25-25" />
  </svg>
);
export default SvgIconLogout;
